import { render, staticRenderFns } from "./diapositiva-5.vue?vue&type=template&id=7d735452&scoped=true&"
import script from "./diapositiva-5.vue?vue&type=script&lang=js&"
export * from "./diapositiva-5.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-5.vue?vue&type=style&index=0&id=7d735452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d735452",
  null
  
)

export default component.exports